export default [
  {
    path: '/users',
    name: 'users',
    component: () => import('./views/UsersList'),
    meta: {
      auth: true
    }
  },
  {
    path: '/users/change-password',
    name: 'users.change-password',
    component: () => import('./views/UsersChangePassword'),
    meta: {
      auth: true
    }
  },
  {
    path: '/users/new',
    name: 'users.new',
    component: () => import('./views/UsersCreate'),
    meta: {
      auth: true
    }
  },
  {
    path: '/users/:id',
    name: 'users.edit',
    component: () => import('./views/UsersCreate'),
    meta: {
      auth: true
    }
  }
]
